import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { signIn, signInWithRedirect } from 'aws-amplify/auth';
import { Form, Input, Button, Layout, Typography, Alert } from 'antd';
import '../styles.css';
import { getUser, redirectIfLogin } from '../functions/userFuncs';
import axios from 'axios';

const { Content } = Layout;
const { Title, Text, Link } = Typography;

const LoginPage: React.FC<{
  logUser: (value: boolean) => void;
  isLogged: boolean;
}> = ({ logUser, isLogged }) => {
  const [form] = Form.useForm();
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    redirectIfLogin(navigate);
    const email = location.state?.email;
    if (email) {
      form.setFieldsValue({ email });
    }
  }, [location.state, form]);

  const handleLogin = async (values: any) => {
    try {
      const { email, password } = values;

      await signIn({ username: email, password });
      logUser(true);
      const fromPage = location.state?.fromPage;
      const formState = location.state?.formState || {};

      const user: any = await getUser();
      if (user) localStorage.setItem('User', JSON.stringify(user.attributes));

      const formID = localStorage.getItem('form_id');

      if (formID) {
        const userData: any = {
          email,
        };
        userData.formID = formID;
        await axios.patch(
          `${process.env.REACT_APP_INSTANCE}/api/report/associate`,
          userData
        );
        localStorage.removeItem('form_id');
      }

      if (location.state?.formPage) {
        navigate('/additional-info', { state: { formState } });
      } else {
        navigate('/status');
      }
    } catch (error) {
      setError(
        'Error logging in. Please check your email and password and try again.'
      );
      console.error('Error logging in:', error);
    }
  };

  const handleSignUpNavigation = () => {
    const fromPage = location.state?.fromPage;
    const formState = location.state?.formState || {};

    if (location.state?.formPage)
      navigate('/signup', { state: { formPage: true } });
    else navigate('/signup');
  };

  const handleGoogleSignIn = async () => {
    try {
      getUser().then(user => {
        localStorage.setItem('User', JSON.stringify(user?.attributes));
      });
      await signInWithRedirect({ provider: 'Google' });

      // revisit this
    } catch (error) {
      setError('Error logging in with Google. Please try again.');
      console.error('Error logging in with Google:', error);
    }
  };

  const navigateToForgotPassword = () => {
    if (location.state?.formPage)
      navigate('/forgot-password', { state: { formPage: true } });
    else navigate('/forgot-password');
  };

  return (
    <Layout className='login-page-background'>
      <Content className='login-layout-content'>
        <Title level={2}>Sign in to your account</Title>
        {error && <Alert message={error} type='error' showIcon />}
        <Form form={form} layout='vertical' onFinish={handleLogin}>
          <Form.Item
            name='email'
            label='Email'
            rules={[{ required: true, message: 'Please enter your email' }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name='password'
            label='Password'
            rules={[{ required: true, message: 'Please enter your password' }]}
          >
            <Input.Password />
          </Form.Item>
          <Form.Item>
            <Button
              type='primary'
              htmlType='submit'
              style={{ marginRight: '10px' }}
            >
              Login
            </Button>
            <Button
              type='default'
              onClick={handleSignUpNavigation}
              style={{ marginRight: '10px' }}
            >
              Sign Up
            </Button>
            <Button type='default' onClick={handleGoogleSignIn}>
              Sign In with Google
            </Button>
          </Form.Item>
        </Form>
        <div style={{ textAlign: 'center' }}>
          <Button type='link' onClick={navigateToForgotPassword}>
            Forgot Password?
          </Button>
        </div>
        <div style={{ textAlign: 'center', marginTop: '20px' }}>
          <Text style={{ color: '#4a4a4a' }}>New to Search By Seeker? </Text>
          <Link style={{ color: '#6A0AC1' }} onClick={handleSignUpNavigation}>
            Create account
          </Link>
        </div>
        <div style={{ display: 'flex', justifyContent: 'center', marginTop: '30px' }}>
            <img
              src='/Asset23@3x.png'
              alt='logo'
              style={{
                width: '150px',
              }}
            />
          </div>
      </Content>
    </Layout>
  );
};

export default LoginPage;
